import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=5976d23c&"
import script from "./Quiz.vue?vue&type=script&lang=js&"
export * from "./Quiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Quiz.vue"
export default component.exports